module.exports = __webpack_public_path__ + "static/assets/b8f0b40efdf6eafc02c3f894a5941818.svg";